export const LAST_NAME_NOT_AVAILABLE = 'N/A';

export const checkLastName = (lastName) =>
  lastName !== LAST_NAME_NOT_AVAILABLE ? lastName : '';

export const ENABLE_RESEND_INVITATION_TIMEFRAME = 24;
